import {DataLayerModel} from "@merchant-webapp/components";

export class FormSubmittedDataLayerModel extends DataLayerModel {
	public static readonly EVENT_NAME: string = "FORM_SUBMITTED";
	public constructor() {
		super(FormSubmittedDataLayerModel.EVENT_NAME);
	}
}